<template>
  <div id="app">
    <div class="scale-container" ref="scaleContainer">
      <div class="main-content">
        <router-view />
      </div>
    </div>
     <footer class="footer">
        <p>Copyright © idruglab. All Rights Reserved</p>
      </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      minScale: 0.5,  // 最小缩放比例
      maxScale: 2.0,  // 最大缩放比例
    }
  },
  mounted() {
    // 防止 ResizeObserver 循环限制报错
    const debounce = (fn, delay) => {
      let timer;
      return (...args) => {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          fn(...args);
        }, delay);
      };
    };
    const resizeObserver = window.ResizeObserver;
    window.ResizeObserver = class extends resizeObserver {
      constructor(callback) {
        callback = debounce(callback, 200);
        super(callback);
      }
    };

    // 添加缩放功能
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.$nextTick(() => {
        const container = this.$refs.scaleContainer;
        if (!container) return;

        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;

        // 基于viewport宽度计算缩放比例
        // 以1920为基准宽度计算比例（你可以根据需要调整这个基准）
        const baseWidth = Math.max(1200, windowWidth); // 确保不小于最小宽度
        let scale = windowWidth / baseWidth;

        // 限制缩放范围
        scale = Math.max(this.minScale, Math.min(this.maxScale, scale));

        // 应用缩放
        container.style.transform = `scale(${scale})`;

        // 容器占满整个视口
        container.style.width = '100%';
        container.style.height = '100%';
        container.style.left = '0';
        container.style.top = '0';
      });
    }
  }
};
</script>

<style>
/* 样式代码 */
*, *::before, *::after {
  box-sizing: border-box;
}
html,
body {
  height: 100%;
  margin: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
  /* 设置最小宽度，避免页面缩小过多 */
  overflow-x: auto;
  /* 当内容宽度超出时，显示水平滚动条 */
  position: relative;
  /* 为缩放容器提供定位基准 */
}

/* 主要内容区域 */
.main-content {
  flex: 1;
  /* 减去footer的高度 */
  padding: 20px;
  /* 给内容底部一些间距 */
}

/* 页面底部样式 */
.footer {
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
  padding: 15px 0;
  text-align: center;
  position: relative;
  bottom: 0;
  width: 100%;
  margin-top: auto;
}

.footer p {
  margin: 0;
  color: #6c757d;
  font-size: 14px;
}

/* 缩放容器样式 */
.scale-container {
  flex: 1; 
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 60px;
}

/* 固定在底部的 footer */
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;           /* 自定义页脚高度 */
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
</style>